var BANK_MATCH_UI_SOURCE = require('../constants/bank-match-ui-source')

module.exports = function getBankMatchTrackingHeaders(uiFlow, objectSource) {
    var headers = {
        'X-Ui-Source': BANK_MATCH_UI_SOURCE,
        'X-Platform': 'web'
    }

    if (uiFlow) {
        headers['X-Ui-Flow'] = uiFlow
    }

    if (objectSource) {
        headers['X-Object-Source'] = objectSource
    }

    return headers
}
